/* eslint-disable react/jsx-max-props-per-line */
/* eslint-disable react/no-multi-comp */
import React, { useEffect, useState } from 'react';
import { Grid, TableCell } from '@mui/material';
import { TableWidgetV2 } from '../../../../components/v2';
import ProdutoFormulario from './ProdutoFormulario';
import { isTrue, moneyFormatter } from 'utils';

const ProdutosContainer = ({ produtos, onSave, disabled, isEntrada, showError }) => {
  const [titles, setTitles] = useState([]);
  const [currentProdutos, setCurrentProdutos] = useState([]);
  const [open, setOpen] = useState(false);
  const [selectedProduto, setSelectedProduto] = useState(null);

  useEffect(() => {
    if (produtos) {
      setCurrentProdutos(produtos);
    }
  }, [produtos]);

  useEffect(() => {
    if (isEntrada) {
      setTitles(['Produto', 'Tamanho', 'Quantidade', 'Valor Unitário', 'Devolução de uso']);
    } else {
      setTitles(['Produto', 'Tamanho', 'Quantidade']);
    }
  }, [isEntrada]);

  const renderRows = p => {
    if (isEntrada) {
      return (
        <>
          <TableCell>{p.produtoNome}</TableCell>
          <TableCell>{p.tamanhoValue ? p.tamanhoValue : "N/A"}</TableCell>
          <TableCell>{p.quantidade || 0}</TableCell>
          <TableCell>{moneyFormatter(p.valorUnitario)}</TableCell>
          <TableCell>{isTrue(p.devolucaoUso) ? "Sim" : "Não"}</TableCell>
        </>
      );
    }

    return (
      <>
        <TableCell>{p.produtoNome}</TableCell>
        <TableCell>{p.tamanhoValue ? p.tamanhoValue : "N/A"}</TableCell>
        <TableCell>{p.quantidade || 0}</TableCell>
      </>
    );
  };

  const onDeleteLocal = id => {
    const products = currentProdutos.filter(p => p.id !== id);
    setCurrentProdutos(products);
    onCloseLocal(products);
  };

  const onCloseLocal = productsToRetrieve => {
    setOpen(false);
    setSelectedProduto(null);
    onSave(productsToRetrieve || currentProdutos);
  };

  const onUpsertProduto = data => {
    let newProdutos = [];

    const existedProducts = currentProdutos.filter(p => p.id === data.id);
    if (existedProducts.length > 0) {
      currentProdutos.forEach(p => {
        if (p.id === data.id) {
          newProdutos.push(data);
        } else {
          newProdutos.push(p);
        }
      });
    } else {
      newProdutos = [...currentProdutos, data];
    }

    setCurrentProdutos(newProdutos);
    onCloseLocal(newProdutos);
  };

  const onEdit = id => {
    setSelectedProduto(currentProdutos.filter(p => p.id === id)[0]);
    setOpen(true);
  };

  return (
    <>
      <Grid size={{ xs: 12 }}>
        <TableWidgetV2
          rows={currentProdutos}
          titles={titles}
          headerTitle="Produtos"
          deleteMessage="Tem certeza que deseja remover o produto"
          renderRows={renderRows}
          hasRowActions
          onDelete={onDeleteLocal}
          onEdit={onEdit}
          hasAdd={disabled === undefined || disabled === false}
          showDelete={disabled === undefined || disabled === false}
          showEdit={disabled === undefined || disabled === false}
          onAdd={() => setOpen(true)}
          showError={showError}
          showEmptyState={false}
        />
      </Grid>
      <ProdutoFormulario
        selectedProduto={selectedProduto}
        open={open}
        onClose={onCloseLocal}
        isEntrada={isEntrada}
        onSave={onUpsertProduto}
      />
    </>
  );
};

export default ProdutosContainer;
